import React from "react";
import { InputBase, Box, useTheme } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

export interface IDataTableV2QuickSearchProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  delay?: number;
  maxWidth?: string | number;
}

export const DataTableV2QuickSearch: React.FC<IDataTableV2QuickSearchProps> = (
  props
) => {
  const {
    value,
    onChange,
    placeholder = "Search...",
    delay = 600,
    maxWidth = "400px",
  } = props;

  const theme = useTheme();
  const [localValue, setLocalValue] = React.useState(value);
  const timerRef = React.useRef<ReturnType<typeof setTimeout> | null>(null);

  // Sync external value changes
  React.useEffect(() => {
    setLocalValue(value);
  }, [value]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setLocalValue(newValue);

    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    timerRef.current = setTimeout(() => {
      onChange(newValue);
    }, delay);
  };

  // Cleanup on unmount
  React.useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        border: `2px solid ${theme.palette.primary.main}`,
        borderRadius: "8px",
        px: 1.5,
        py: 0.5,
        width: "100%",
        maxWidth: maxWidth,
        backgroundColor: "#fff",
      }}
    >
      <SearchIcon
        sx={{
          color: theme.palette.primary.main,
          mr: 1,
          fontSize: "20px",
        }}
      />
      <InputBase
        fullWidth
        placeholder={placeholder}
        value={localValue}
        onChange={handleChange}
        sx={{
          fontSize: "0.875rem",
          "& .MuiInputBase-input": {
            padding: "4px 0",
            "&::placeholder": {
              opacity: 0.7,
              color: theme.palette.primary.main,
            },
          },
        }}
      />
    </Box>
  );
};
